<template>
  <div class="card">
    <div class="card-header">
      <div class="card-header-title">Clientes Alcançados</div>
    </div>
    <div class="card-content">
      <div class="level">
        <div class="level-right">
          <div class="level-item">
            <b-button
              @click="export2Csv"
              type="is-info"
              icon-right="cloud-download-alt"
              size="is-small"
              :disabled="isLoading"
              >Exportar Lista</b-button
            >
          </div>
        </div>
      </div>
      <b-table
        :data="fields"
        :columns="labels"
        :paginated="true"
        :pagination-simple="true"
        :per-page="perPage"
        striped
        bordered
      >
        <template slot="footer">
          <div class="level" style="padding-bottom: 0">
            <div class="level-left"></div>
            <div class="left-center"></div>
            <div class="level-right">
              <b-select v-model="perPage" size="is-small">
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </b-select>
            </div>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "@/store";
import Webservices from "@/Webservices";

var FileSaver = require("file-saver");
const Json2csvParser = require("json2csv").Parser;
var moment = require("moment");

const ws = new Webservices();

export default {
  name: "tableSms",
  props: {
    smsID: {
      type: Number
    }
  },
  data() {
    return {
      perPage: 10,
      isLoading: false,

      fields: [],
      labels: [
        {
          field: "userNumber",
          label: "Número",
          centered: true
        },
        {
          field: "timestamp",
          label: "Data",
          centered: true
        }
      ]
    };
  },
  mounted() {
    ws.getSmsSent(this.smsID).then(response => {
      let data = response.data;
      this.fields = data;
    });
  },
  watch: {
    question(newValue) {
      this.users = [];
      this.isLoading = true;
    }
  },
  methods: {
    export2Csv() {
      const json2csvParser = new Json2csvParser(this.labels);
      const csv = json2csvParser.parse(this.getUsers);

      var blob = new Blob([csv], {
        type: "text/csv"
      });

      FileSaver.saveAs(blob, "respostas.csv");
    }
  },
  computed: {
    getUsers() {
      return this.fields;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/custom/tableSms.vue